import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ReWeighingDto } from "./re-weighment.dto";

export class RmReWeighingResponse extends GlobalResponseObject {
    data?: ReWeighingDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /ProductDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: ReWeighingDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}